<template>
  <div v-if="user.id" class="profile">
    <!-- {{ $store.getters.isAgent }}
    {{ $store.getters.isCandidate }}
    {{ $store.getters.isEmployer }} -->
    <!-- {{ user }} -->
    <div class="profile-tile" style="margin-top: 20px;">
      <basic-info :user="user" @editBasicInfo="editBasicInfo()"></basic-info>
    </div>

    <!-- <div class="profile-tile" v-if="$store.getters.candidateStatuses.indexOf(user.status) >= $store.getters.candidateStatuses.indexOf('Passed Interview 2')"> -->
    <div class="profile-tile">
      <h3 style="">Personal Summary
        <span v-if="editAccess" style="cursor: pointer; float: right;">
          <!-- <span style="color: #757575; font-size: 1.5rem;">Edit </span><img class="mb-1 ml-1" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" @click="editPersonalSummary()"> -->
          <button class="btn btn-light" @click="editPersonalSummary()">Edit</button>
        </span>
      </h3>
      <hr>
      <pre v-if="user.text15">{{ user.text15 }}</pre>
      <p v-if="!user.text15 && editAccess">Please write your personal summary! Sell yourself, what makes you great? This is what families will see!</p>
    </div>

    <div class="profile-tile" v-if="editAccess">
      <h3 style="">Professional Information
        <img v-if="editAccess" class="mb-1 ml-1" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="cursor: pointer; float: right;" @click="editProfessionalInfo()">
      </h3>
      <hr style="margin-bottom: 0px;">
      <professional-info :user="user"></professional-info>
    </div>

    <div class="profile-tile">
      <div v-if="user.id">
        <references :user="user"></references>
      </div>
    </div>

    <!-- <div class="profile-tile">
      <h3 style="">Placement Details
        <img v-if="editAccess" class="mb-1 ml-1" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="cursor: pointer; float: right;" @click="editDesiredRole()">
      </h3>
      <hr>
      <desired-role :user="user"></desired-role>
    </div> -->

    <div class="profile-tile">
      <div v-if="user.id">
        <experiences :user="user"></experiences>
      </div>
    </div>

    <div class="profile-tile" v-if="editAccess">
      <div v-if="user.id">
        <documents :user="user" @infoSaved="infoSaved()"></documents>
      </div>
    </div>

    <div class="profile-tile" v-if="adminOrEmployer">
    <!-- <div class="profile-tile" v-if="$store.getters.isAgent === true"> -->
      <h3 style="">Agency Notes
        <img v-if="$store.getters.isAgent === true" class="mb-1 ml-1" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="cursor: pointer; float: right;" @click="editNotes()">
      </h3>
      <strong v-if="$store.getters.isAgent === true">Please keep in mind that clients will see these notes!</strong>
      <hr>
      <pre>{{ user.text20 }}</pre>
    </div>

    <div v-if="user.status == 'Interview Complete' && editAccess">
      <button class="mylisting-button dark-button center mt-5" style="text-transform: uppercase" @click="submitApplication()">My profile is complete!</button>
    </div>

    <div v-if="user.id && !$store.getters.isAgent">
      <feedback :user="user"></feedback>
    </div>

    <modal name="basic-info-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <basic-info-form @basicInfoSaved="basicInfoSaved()" :user="user"></basic-info-form>
      </div>
    </modal>

    <modal name="personal-summary-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <personal-summary-form @infoSaved="infoSaved()" :user="user"></personal-summary-form>
      </div>
    </modal>

    <modal name="professional-info-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <!-- <professional-info-form @professionalInfoSaved="professionalInfoSaved()" :user="user"></professional-info-form> -->
        <professional-info-form @infoSaved="infoSaved()" :user="user"></professional-info-form>
      </div>
    </modal>

    <modal name="desired-role-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <desired-role-form @infoSaved="infoSaved()" :user="user"></desired-role-form>
      </div>
    </modal>

    <modal name="notes-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <notes-form @infoSaved="infoSaved()" :user="user"></notes-form>
      </div>
    </modal>

    <modal name="completed-application-modal" width="60%" height="auto" :scrollable='true' style="z-index: 9999;">
      <!-- <div class="p-5" v-if="user.id"> -->
      <div class="p-5">
        <!-- <h3>Thank you for completing your {{ submissionType }}!</h3> -->
        <h3>Thank you!</h3>
        <p>We will review your profile and be in touch with you soon.</p>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('completed-application-modal')" style="">Close</button>
      </div>
    </modal>

  </div>
</template>

<script>
import axios from 'axios'

// https://www.npmjs.com/package/vue-loading-overlay
import Vue from 'vue';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
Vue.use(Loading);

import BasicInfo from './BasicInfo'
import BasicInfoForm from './BasicInfoForm'
import ProfessionalInfo from './ProfessionalInfo'
import ProfessionalInfoForm from './ProfessionalInfoForm'
import DesiredRole from './DesiredRole'
import DesiredRoleForm from './DesiredRoleForm'
import References from './References'
import Documents from './Documents'
import NotesForm from './NotesForm'
import Experiences from './Experiences'
import PersonalSummaryForm from './PersonalSummaryForm'

// Users
// import Resources from "../../users/Resources";
import Feedback from "../../users/Feedback"

export default {
  props: ['user'],
  components: {
    BasicInfo,
    BasicInfoForm,
    ProfessionalInfo,
    ProfessionalInfoForm,
    DesiredRole,
    DesiredRoleForm,
    References,
    Documents,
    NotesForm,
    Experiences,
    PersonalSummaryForm,
    Feedback,
  },
  computed: {
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    // viewOnlyAccess() {
    //   if (this.$store.getters.isEmployer === 'true') {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    },
  },
  data() {
    return {
      // user: {},
      // passedID: null,
    }
  },
  created() {
    // this.user = this.passedUser
    // this.passedID = this.$route.params.id
    // if (this.passedID) {
    //   this.getUser()
    // }
  },
  methods: {
    // getUser() {
    //   axios.get('/api/people/?id='.concat(this.passedID.toString()))
    //   .then(res => {
    //     console.log(res.data)
    //     this.user = res.data[0]
    //   })
    //     .catch(error => console.log(error))
    // },
    editBasicInfo() {
      this.$modal.show('basic-info-modal')
    },
    editPersonalSummary() {
      this.$modal.show('personal-summary-modal')
    },
    editProfessionalInfo() {
      this.$modal.show('professional-info-modal')
    },
    editDesiredRole() {
      this.$modal.show('desired-role-modal')
    },
    editNotes() {
      this.$modal.show('notes-modal')
    },
    basicInfoSaved() {
      this.$modal.hide('basic-info-modal')
      // this.getUser()
      this.$emit('userUpdated')
    },
    professionalInfoSaved() {
      this.$modal.hide('professional-info-modal')
      this.$emit('userUpdated')
    },
    infoSaved() {
      this.$modal.hide('basic-info-modal')
      this.$modal.hide('professional-info-modal')
      this.$modal.hide('desired-role-modal')
      this.$modal.hide('notes-modal')
      this.$modal.hide('personal-summary-modal')
      this.$emit('userUpdated')
    },
    submitApplication() {
      // // Empty the list of missing fields from previous submits
      // this.missingFields = []

      // // Get the amount of references this candidate has submitted
      // axios.get('/api/references/?user='+this.user.id)
      //   .then(res => {
      //     // console.log(res.data)
      //     this.references = res.data.length
      //     console.log(this.references)
      //   })
      //   .catch(error => console.log(error))

      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.fullPage ? null : this.$refs.formContainer,
      //   // container: this.$refs.formContainer,
      //   // canCancel: true,
      //   canCancel: false,
      //   // onCancel: this.onCancel,
      // });
      // // simulate AJAX
      // setTimeout(() => {
      //   loader.hide()

      //   // Check if required fields are filled in
      //   if (this.user.first_name && this.user.last_name && this.user.email && this.user.phone
      //       && this.user.boolean_selector1 && this.user.boolean_selector4
      //       && this.user.text2 && this.user.text4 && this.user.text10 && this.user.preferences.length >= 1
      //       && this.user.skills.length >= 1 && this.user.skills2.length >= 1
      //       && this.user.features.length >= 1 && this.user.preferences2.length >= 1 && this.user.available_date
      //       && this.user.text1 && this.user.text7 && this.user.text8
      //       && this.references >= 3
      //   )
      //   {
      //     // Change the local saved status to hide button to prevent duplicate emails being sent
      //     this.status = 'Application Pending Review'

      //     // Send email to notify of application profile completion
      //     this.$store.dispatch('sendEmails',
      //       {
      //         subject: 'Candidate Profile Completed ' + this.user.first_name + ' ' + this.user.last_name,
      //         message: 'Candidate Application completed by: ' + this.user.first_name + ' ' + this.user.last_name + ' | ' + this.user.email,
      //         from: this.$store.getters.agencyFromEmail,
      //         emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail3],
      //         // emails: [this.$store.getters.enginehireLoggingEmail],
      //         reply: this.$store.getters.agencyReplyEmail,
      //         // userID: this.aakashid,
      //         userID: 4,
      //       }
      //     )

      //     // Update the status of the candidate in the database
      //     axios.patch('/api/people/' + this.user.id + '/', {
      //       status: this.status,
      //     })

      //     this.submissionType = 'application'
      //     this.$modal.show('completed-application-modal')

      //   } else {
      //     // console.log('Missing fields')
      //     this.$modal.show('missing-fields-modal')

      //     // Check each to see which required fields are missing and add them to list to display to candidate
      //     if (!this.user.first_name) {
      //       // console.log('Need first name')
      //       this.missingFields.push('First name')
      //     }
      //     if (!this.user.last_name) {
      //       // console.log('Need last name')
      //       this.missingFields.push('Last name')
      //     }
      //     if (!this.user.email) {
      //       // console.log('Need email')
      //       this.missingFields.push('Email')
      //     }
      //     if (!this.user.phone) {
      //       // console.log('Need phone')
      //       this.missingFields.push('Phone number')
      //     }
      //     if (this.user.preferences.length < 1) {
      //       // console.log('Need positions')
      //       this.missingFields.push('Positions applying for')
      //     }
      //     if (!this.user.boolean_selector1) {
      //       // console.log('Need license')
      //       this.missingFields.push('Drivers license check')
      //     }
      //     if (!this.user.boolean_selector4) {
      //       // console.log('Need graduated')
      //       this.missingFields.push('High school graduation check')
      //     }
      //     if (!this.user.text2) {
      //       // console.log('Need vehicle')
      //       this.missingFields.push('Vehicle year, make & model')
      //     }
      //     if (!this.user.text10) {
      //       // console.log('Need high school')
      //       this.missingFields.push('High school name')
      //     }
      //     if (this.user.skills.length < 1) {
      //       // console.log('Need ages')
      //       this.missingFields.push('Ages you have experience with')
      //     }
      //     if (this.user.skills2.length < 1) {
      //       // console.log('Need experiences')
      //       this.missingFields.push('Types of experiences you have had')
      //     }
      //     if (!this.user.text4) {
      //       // console.log('Need languages')
      //       this.missingFields.push('Languages you speak fluently')
      //     }
      //     if (this.user.features.length < 1) {
      //       // console.log('Need documents')
      //       this.missingFields.push('Check documents you can provide')
      //     }
      //     if (this.user.preferences2.length < 1) {
      //       // console.log('Need days available')
      //       this.missingFields.push('Days of the week you are available')
      //     }
      //     if (!this.user.available_date) {
      //       // console.log('Need start date')
      //       this.missingFields.push('Date you can start')
      //     }
      //     if (!this.user.text7) {
      //       // console.log('Need hours per week')
      //       this.missingFields.push('How many hours you are looking to work per week')
      //     }
      //     if (!this.user.text8) {
      //       // console.log('Need schedule considerations')
      //       this.missingFields.push('Any schedule considerations')
      //     }
      //     if (!this.user.text1) {
      //       // console.log('Need ideal family')
      //       this.missingFields.push('Your ideal nanny family')
      //     }
      //     if (this.references < 3) {
      //       this.missingFields.push('Three references required')
      //     }
      //   }
      // },3000)

      // Send email to notify of application profile completion
      this.$store.dispatch('sendEmails',
        {
          subject: 'Candidate Profile Completed ' + this.user.first_name + ' ' + this.user.last_name,
          message: 'Candidate Application completed by: ' + this.user.first_name + ' ' + this.user.last_name + ' | ' + this.user.email,
          from: this.$store.getters.agencyFromEmail,
          emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail2],
          reply: this.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: 4,
        }
      )

      // Update the status of the candidate in the database
      axios.patch('/api/people/' + this.user.id + '/', {
        status: 'Profile Pending Review',
      })
        .then(res => {
          this.user.status = 'Profile Pending Review'
          this.$emit('userUpdated')
          this.$modal.show('completed-application-modal')
        })
    },
  },
}
</script>

<style>
  /* .profile-tile {
    border-radius: 6px;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    padding: 1.5rem;
    margin-top: 40px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/candidates/profile/ProfileView.vue